import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot } from "firebase/firestore";
import { auth, db, storage, messaging } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import WarningAmber from '@mui/icons-material/WarningAmber';
import Icon from '@mui/material/Icon';
import { Select, MenuItem, FormControl, InputLabel, TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [file, setFile ] = useState("")
  // const [ data, setData ] = useState({})
  const [title, setTitle] = useState("")
  const [message, setMessage] = useState("")
  // const [ perc, setPerc ] = useState(null)
  const [plan, setPlan ] = useState("")
  const [premiumList, setPremiumList] = useState([])
  const [platinumList, setPlatinumList] = useState([])
  const [standardList, setStandardList] = useState([])
  const [icon, setIcon] = React.useState('');
  const [iconColor, setIconcolor] = useState("")
  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }



   useEffect(() => {
  
  
      const collectionRef = collection(db, "subscribers")
  
      const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Platinum"))
  
      const unsub = onSnapshot(querySubscribers, (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push(doc.data().userId)
        })
        setPlatinumList(list)
      }, 
        (error) => {
          console.log(error)
        }
      );
  
      return () => {
        unsub();
      }
  
  //END LISTEN REAL TIME    
  
    },[])


    useEffect(() => {
  
  
      const collectionRef = collection(db, "subscribers")
  
      const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Premium"))
  
      const unsub = onSnapshot(querySubscribers, (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push(doc.data().userId)
        })
        setPremiumList(list)
      }, 
        (error) => {
          console.log(error)
        }
      );
  
      return () => {
        unsub();
      }
  
  //END LISTEN REAL TIME    
  
    },[])


    useEffect(() => {
  
  
      const collectionRef = collection(db, "subscribers")
  
      const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Standard"))
  
      const unsub = onSnapshot(querySubscribers, (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push( doc.data().userId )
        })
        setStandardList(list)
      }, 
        (error) => {
          console.log(error)
        }
      );
  
      return () => {
        unsub();
      }
  
  //END LISTEN REAL TIME    
  
    },[])


  const handleChange = (event) => {
    setPlan(event.target.value);
  };

   const handleChangeIcon = (event) => {
    setIcon(event.target.value);
  };

  const handleChangeIconColor = (event) => {
    setIconcolor(event.target.value);
  };


  const handleAdd = async(e) => {

          e.preventDefault()

          if(premiumList){

              setIsloading(true)

              const batch = writeBatch(db);

              premiumList.forEach((item) => {

                const messageData = {
                  userId: item, 
                  title: title,
                  message1: message,
                  message2: "",
                  message3: "",
                  plan: plan,
                  iconName: icon,
                  iconColor: iconColor,
                  status: "unread",
                  date : today
                }

                const docRef = doc(collection(db, "messages"));
                batch.set(docRef, messageData); 
              });

              await batch.commit();

              setIsloading(false)

              navigate('/messages')


          }

          
          if(platinumList){

              setIsloading(true)

              const batch = writeBatch(db);

              platinumList.forEach((item) => {

                const messageData = {
                 userId: item, 
                  title: title,
                  message1: message,
                  message2: "",
                  message3: "",
                  plan: plan,
                  iconName: icon,
                  iconColor: iconColor,
                  status: "unread",
                  date : today
                }

                const docRef = doc(collection(db, "messages"));
                batch.set(docRef, messageData); 
              });

              await batch.commit();

              setIsloading(false)

              navigate('/messages')


          }
      

           if(standardList){

              setIsloading(true)

              const batch = writeBatch(db);

              standardList.forEach((item) => {

                const messageData = {
                 userId: item, 
                  title: title,
                  message1: message,
                  message2: "",
                  message3: "",
                  plan: plan,
                  iconName: icon,
                  iconColor: iconColor,
                  status: "unread",
                  date : today
                }

                const docRef = doc(collection(db, "messages"));
                batch.set(docRef, messageData); 
              });

              await batch.commit();

              setIsloading(false)

              navigate('/messages')


          }
      
       
  }


  const selectoptions = [{
    value: 'platinum',
    label: 'Platinum Users'
  },
  {
    value: 'premium',
    label: 'Premium Users'
  },
  {
    value: 'standard',
    label: 'Standard Users'
  }
];


  const selectIcon = [
  {
    value: 'customerservice',
    label: 'Customer Service Icon',
    icon: ''
  },
   {
    value: 'info-circle',
    label: 'Info Icon',
    icon: ''
  },
  {
    value: 'warning',
    label: 'Warning Icon',
    icon: ''
  },
  {
    value: 'safety',
    label: 'Safety Icon',
    icon: ''
  },
  {
    value: 'payment',
    label: 'Payment Icon',
    icon: ''
  },
   {
    value: 'clockcircle0',
    label: 'Time',
    icon: ''
  },
  {
    value: 'trophy',
    label: 'Trophy Icon',
    icon: ''
  },
  {
    value: 'bulb1',
    label: 'Bulb Icon',
    icon: ''
  },
  {
    value: 'rocket1',
    label: 'Rocket Icon',
    icon: ''
  },
    

];


 const selectColor = [
  {
    value: '#000',
    label: 'Black',
    code: '#000'
  },
  {
    value: '#c61a09',
    label: 'Red',
    code: '#c61a09'
  },
  
];



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Message</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/messages"
            >
              Message List
            </Link>
            <Typography color="green">New Message</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
          <div className='right'>
            <div className='form' onSubmit={handleAdd}>

                   <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="plan" style={{color:'#999', fontWeight:300}}>Select Subscriber Type</InputLabel>
                    <Select
                      labelId="plan"
                      id="plan"
                      value={plan}
                      label="Plan"
                      onChange={handleChange}
                      // renderValue={(plan) => {
                      //   if (plan === "") {
                      //     return <em>Choose Subscriber</em>;
                      //   }

                      //   return plan;
                      // }}
                    >
                      {/* <MenuItem value="">Choose Subscriber</MenuItem> */}

                      {selectoptions.map((item) => { 

                        return(

                          <MenuItem value={item.value}>{item.label}</MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>

                 
                  <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Message Icon</InputLabel>
                    <Select
                      labelId="icon"
                      id="icon"
                      value={icon}
                      label="Icon"
                      onChange={handleChangeIcon}
                      // renderValue={(plan) => {
                      //   if (plan === "") {
                      //     return <em>Choose Subscriber</em>;
                      //   }

                      //   return plan;
                      // }}
                    >
                      {/* <MenuItem value="">Choose Subscriber</MenuItem> */}

                      {selectIcon.map((item) => { 

                        return(

                          <MenuItem value={item.value}>
                           {/* <Icon color="primary" style={{marginRight:10}}> {item.icon } </Icon> */}
                            {item.label}
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>


                  <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Icon Color</InputLabel>
                    <Select
                      labelId="color"
                      id="color"
                      value={iconColor}
                      label="Icon Color"
                      onChange={handleChangeIconColor}
                
                    >
                      {/* <MenuItem value="">Choose Subscriber</MenuItem> */}

                      {selectColor.map((item) => { 

                        return(

                          <MenuItem value={item.value}>
                           {/* <Icon color="primary" style={{marginRight:10}}> {item.icon } </Icon> */}
                            
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', gap:40}}>
                                {item.label}
                                <div style={{width:20, height:20, backgroundColor:item.code}}></div>
                            </div>
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>
                    <TextField
                      id="title"
                      onChange={(e) => setTitle(e.target.value)}
                      value = {title}
                      placeholder="Enter Title"
                      style={{width:'50%'}}


                    />
                    

                    <TextField
                      id="message" 
                      value={message}
                      multiline
                      minRows={3}
                      maxRows={10}
                      placeholder="Enter Message"
                      style={{width:'50%'}}
                      onChange={(e) => setMessage(e.target.value)}
                    />


              <Button onClick={handleAdd} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? <Spinner/>: 'Submit'}</Button>

             {/* <button disabled={perc !== null && perc < 100} type='submit' >Submit</button> */}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New
